import type { infra } from '@photo-vault/shared';
import { awsInfraProvider } from './aws/index.js';

// Build-time switch. Today only 'aws' is implemented; the seam exists so a
// future 'p2p' bundle can ship by exporting a P2pInfraProvider and adding it
// to the union below. Tree-shaking keeps the unused branch out of the bundle.
const mode = ((import.meta.env['VITE_INFRA_MODE'] as string | undefined) ?? 'aws') as 'aws' | 'p2p';

export function createInfraProvider(): infra.InfraProvider {
  switch (mode) {
    case 'aws':
      return awsInfraProvider;
    case 'p2p':
      throw new Error('VITE_INFRA_MODE=p2p not yet implemented');
    default: {
      const _exhaustive: never = mode;
      void _exhaustive;
      throw new Error(`unknown VITE_INFRA_MODE: ${mode as string}`);
    }
  }
}
